import { MediaStatus } from "./Media.types";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { SvgIconComponent } from "@mui/icons-material";


const STATUS_CONFIG: Record<
  MediaStatus,
  {
    label: string;
    icon?: SvgIconComponent;
    badgeClass: string;
  }
> = {
  VERIFIED: {
    label: "Verified",
    icon: CheckCircleOutlineIcon,
    badgeClass:
      "px-3 py-1 rounded-full bg-green-100 text-green-700 border border-green-200",
  },

  REJECTED: {
    label: "Rejected",
    icon: HighlightOffIcon,
    badgeClass:
      "px-3 py-1 rounded-full bg-red-100 text-red-700 border border-red-200",
  },

  VERIFICATION_PENDING: {
    label: "Verification Pending",
    icon: HourglassEmptyIcon,
    badgeClass:
      "px-3 py-1 rounded-full bg-blue-100 text-blue-700 border border-blue-200",
  },

  UN_VERIFIED: {
    label: "Unverified",
    badgeClass:
      "px-3 py-1 rounded-full bg-gray-100 text-gray-600 border border-gray-200",
  },
};

const FILTER_TABS : Array<{
  value: MediaStatus | "ALL";
  label: string;
}> = [
  { value: "VERIFICATION_PENDING", label: "Verification Pending" },
  { value: "VERIFIED", label: "Verified" },
  { value: "REJECTED", label: "Rejected" },
  { value: "ALL", label: "All" },
//   { value: "UN_VERIFIED", label: "Unverified" },
];

const REJECTION_REASONS_OPTIONS = [
    { label: "Low quality image", value: "Low quality image" },
    { label: "Incorrect branding", value: "Incorrect branding" },
    { label: "Irrelevant content", value: "Irrelevant content" },
    { label: "Copyright issue", value: "Copyright issue" },
    { label: "Sensitive / unsafe content", value: "Sensitive / unsafe content" },
    { label: "Duration should be less than 60 second", value: "Duration should be less than 60 second" },
    { label: "Other", value: "Other" },
  ];

export { STATUS_CONFIG, FILTER_TABS, REJECTION_REASONS_OPTIONS };